// // Mindmap.jsx
// import { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import ReactFlow, { Background } from 'reactflow';
// import 'reactflow/dist/style.css';

// const Mindmap = () => {
//   const { postId } = useParams();
//   const [mindmap, setMindmap] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetch(`/api/generate-mindmap/${postId}/`)
//       .then(res => res.json())
//       .then(data => {
//         setMindmap(data.mindmap);
//         setLoading(false);
//       });
//   }, [postId]);

//   if (loading) return <div>🔄 Generating mindmap...</div>;
//   if (!mindmap) return <div>No recording found</div>;

//   // Convert JSON to ReactFlow nodes/edges
//   const nodes = mindmap.nodes.map(node => ({
//     id: node.id,
//     data: { label: node.text },
//     position: { x: Math.random() * 400, y: Math.random() * 400 },
//     style: { 
//       background: '#4f46e5', 
//       color: 'white',
//       borderRadius: 10,
//       padding: 12 
//     }
//   }));

//   const edges = []; // Build from children relations

//   return (
//     <div style={{ height: '100vh', width: '100%' }}>
//       <ReactFlow nodes={nodes} edges={edges}>
//         <Background />
//         <div style={{ position: 'absolute', top: 10, left: 10 }}>
//           <h1>📚 Session Mindmap</h1>
//           <p>{mindmap.summary}</p>
//         </div>
//       </ReactFlow>
//     </div>
//   );
// };
// export default Mindmap

// Mindmap.jsx (Debug Version)
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReactFlow, { Background } from 'reactflow';
import 'reactflow/dist/style.css';

const Mindmap = () => {
  const { postId } = useParams();
  const [mindmap, setMindmap] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // SAMPLE DATA for instant testing
  const SAMPLE_MINDMAP = {
    summary: "Sample lecture about programming concepts and best practices.",
    nodes: [
      { id: "root", text: "Programming Basics", children: ["n1", "n2"] },
      { id: "n1", text: "Python", children: ["n1.1"] },
      { id: "n2", text: "FastAPI", children: [] },
      { id: "n1.1", text: "Syntax", children: [] }
    ]
  };

  useEffect(() => {
    console.log("🧠 Fetching mindmap for:", postId);
    
    // SAMPLE MODE (instant)
    if (postId === 'test' || postId === 'sample') {
      console.log("✅ Using SAMPLE data");
      setMindmap(SAMPLE_MINDMAP);
      setLoading(false);
      return;
    }

    // API CALL
    fetch(`/api/generate-mindmap/${postId}/`)
      .then(res => {
        console.log("API Status:", res.status);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => {
        console.log("✅ API Response:", data);
        setMindmap(data.mindmap || data);
        setLoading(false);
      })
      .catch(err => {
        console.error("❌ API Error:", err);
        setError(err.message);
        setLoading(false);
        // Fallback to sample
        setMindmap(SAMPLE_MINDMAP);
      });
  }, [postId]);

  if (loading) return (
    <div style={{ padding: '50px', textAlign: 'center' }}>
      🔄 Generating mindmap... (or test with /mindmap/test)
    </div>
  );
  
  if (error) return (
    <div style={{ padding: '50px', color: 'orange' }}>
      ⚠️ {error} 
      <br/>Using sample data instead 👇
    </div>
  );

  // Safe node conversion (handles missing data)
  const nodes = (mindmap?.nodes || []).map((node, i) => ({
    id: node.id || `node-${i}`,
    data: { label: node.label || node.text || 'Topic' },
    position: { 
      x: (i * 150) % 800 - 400, 
      y: Math.sin(i * 0.5) * 200 
    },
    style: { 
      background: '#6366f1', 
      color: 'white',
      borderRadius: 12,
      padding: 16,
      fontSize: 14,
      fontWeight: 500
    }
  }));

  const edges = []; // Add later

  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <ReactFlow 
        nodes={nodes} 
        edges={edges}
        fitView
        minZoom={0.3}
        maxZoom={2}
      >
        <Background />
        <div style={{ 
          position: 'absolute', 
          top: 20, left: 20, 
          background: 'rgba(0,0,0,0.8)', 
          color: 'white', 
          padding: '20px', 
          borderRadius: 12 
        }}>
          <h2>📚 {mindmap?.title || 'Session Mindmap'}</h2>
          <p style={{ margin: 0, fontSize: 14 }}>
            {mindmap?.summary || 'Summary loading...'}
          </p>
          <small>Post ID: {postId} | Nodes: {nodes.length}</small>
        </div>
      </ReactFlow>
    </div>
  );
};

export default Mindmap;